import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageCousinA.module.scss";

function PageCousinA() {
  const getImgSet = useImgSet();

  const item01 = getImgSet("item__01__p30", "png");
  const pointer = getImgSet("pointer__cousin", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__04__alt", "png", s.img__a);
  const imgB = getImgSet("bear__05__alt", "png", s.img__b);
  const imgC = getImgSet("img__p30", "png", s.img__c);
  const description = getImgSet("description__p30", "png", s.description);
  const notice = getImgSet("notice__p30", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/cousin/" className={s.back}>
          {back}
        </Link>
        <div className={s.bears}>
          {imgA}
          {imgB}
        </div>
        <Link to="/cousin/b" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>
        <Link to="/cousin/c" className={cn(s.item, s.item__01)}>
          {item01}
        </Link>
      </div>
      <div className={s.aside_right}>
        {imgC}
        {description}
      </div>
    </div>
  );
}

export default withLayoutSimple(PageCousinA, false, true, true, true);
